import { render, staticRenderFns } from "./AuthenticateDomain.vue?vue&type=template&id=312b22d6"
import script from "./AuthenticateDomain.vue?vue&type=script&lang=js"
export * from "./AuthenticateDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports